import cx from 'classnames';
import React from 'react';

export interface ContentLayoutProps {
	children: React.ReactNode;
	customClasses?: string;
}

export const ContentLayout = ({
	children,
	customClasses,
}: ContentLayoutProps) => (
	<section
		className={cx(
			'-ml-(--container-padding-horizontal)! -mr-(--container-padding-horizontal)! p-(--templates-margin-l) bg-(--background-block-primary) [ md:ml-0! md:mr-0! md:rounded-3xl ]',
			customClasses
		)}>
		{children}
	</section>
);

export const ServiceContentLayout = ({
	children,
	customClasses,
}: ContentLayoutProps) => (
	<ContentLayout customClasses={customClasses}>{children}</ContentLayout>
);
